export default __webpack_public_path__ + "static/media/abbeville8.257f4bbf.jpg";